import { Component } from '@angular/core';

@Component({
  selector     : 'nz-demo-collapse',
  preserveWhitespaces: false,
  templateUrl  : './en.html'
})
export class NzDemoCollapseEnComponent {

}
